"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formTemplateHelper = require("../../../helpers/formTemplateHelper");
var _formValidations = require("../../../helpers/formValidations");
var _WithdrawWorkflowsContainer = _interopRequireDefault(require("../WithdrawWorkflows/WithdrawWorkflowsContainer"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _APNumberInput = _interopRequireDefault(require("../../common/APNumberInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WithdrawTemplateFormComponent = /*#__PURE__*/function (_React$Component) {
  function WithdrawTemplateFormComponent() {
    var _this;
    _classCallCheck(this, WithdrawTemplateFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WithdrawTemplateFormComponent, [].concat(args));
    _defineProperty(_this, "onMaxClick", function () {
      var _this$props = _this.props,
        onAmountChange = _this$props.onAmountChange,
        change = _this$props.change,
        balance = _this$props.balance;
      change('createWithdraw', 'Amount', balance);
      onAmountChange(balance);
    });
    return _this;
  }
  _inherits(WithdrawTemplateFormComponent, _React$Component);
  return _createClass(WithdrawTemplateFormComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        product = _this$props2.product,
        _this$props2$product = _this$props2.product,
        Product = _this$props2$product.Product,
        ProductId = _this$props2$product.ProductId,
        DecimalPlaces = _this$props2$product.DecimalPlaces,
        withdrawWorkflowInfo = _this$props2.withdrawWorkflowInfo,
        submitting = _this$props2.submitting,
        invalid = _this$props2.invalid,
        baseClasses = _this$props2.baseClasses,
        onAmountChange = _this$props2.onAmountChange,
        children = _this$props2.children,
        errorMessage = _this$props2.errorMessage,
        disableWithdraw = _this$props2.disableWithdraw,
        VerificationRequiredComponent = _this$props2.VerificationRequiredComponent;
      var useExternalWorkflow = withdrawWorkflowInfo && Object.values(withdrawWorkflowInfo).length;
      var template = _objectSpread({}, this.props.template);
      if ('ExternalAddress' in template) {
        // Has to be a new object adding/modifying a prop causes infinite renders AW-515
        template = _objectSpread({
          ExternalAddress: Product
        }, this.props.template);
      }
      return Object.keys(template).length && ProductId ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('wrapper')
      }, !Object.prototype.hasOwnProperty.call(template, 'Amount') && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-with-btn')
      }, /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
        type: "text",
        key: "Amount",
        name: "Amount",
        "data-test": "Amount",
        label: t('Amount'),
        customClass: baseClasses(''),
        decimalPlaces: DecimalPlaces,
        customChange: function customChange(value) {
          return onAmountChange(+value);
        },
        validate: [_formValidations.required, _formValidations.greaterThanZero]
      }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: baseClasses('max'),
        type: "button",
        styleName: "additive",
        onClick: this.onMaxClick
      }, t('Max'))), errorMessage && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error-message')
      }, errorMessage), !useExternalWorkflow && (0, _formTemplateHelper.templateFormRenderer)(template, baseClasses(''), {
        t: t
      }, product)), /*#__PURE__*/_react["default"].createElement(_WithdrawWorkflowsContainer["default"], null), !useExternalWorkflow && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('section')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: baseClasses(),
        type: "submit",
        disabled: submitting || invalid || disableWithdraw,
        styleName: "subtractive"
      }, submitting ? t('Submitting...') : t('Place Withdraw Ticket')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('verification-required-text')
      }, VerificationRequiredComponent)))) : /*#__PURE__*/_react["default"].createElement("div", null);
    }
  }]);
}(_react["default"].Component);
WithdrawTemplateFormComponent.defaultProps = {
  template: {},
  product: {},
  submitting: false,
  baseClasses: function baseClasses() {},
  onAmountChange: function onAmountChange() {},
  VerificationRequiredComponent: null
};
WithdrawTemplateFormComponent.propTypes = {
  template: _propTypes["default"].object,
  product: _propTypes["default"].shape({
    Product: _propTypes["default"].string,
    ProductId: _propTypes["default"].number,
    DecimalPlaces: _propTypes["default"].number
  }),
  submitting: _propTypes["default"].bool,
  baseClasses: _propTypes["default"].func,
  onAmountChange: _propTypes["default"].func,
  VerificationRequiredComponent: _propTypes["default"].element
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(WithdrawTemplateFormComponent);